export default __webpack_public_path__ + "static/media/business-16A.94e571f0.jpg";